module.exports = {
  project_env: 'website_v3', // brush: 刷脸屏官网    website: 扁鹊官网  newwebsite: 扁鹊官网迭代 website_v3: 官网第三版

  brushServeUrl: 'http://face.bechangedt.com/', // 刷脸屏线上地址
  websiteServeUrl: 'http://www.bechangedt.com/', // 扁鹊官网线上地址

  forRecord: 'https://beian.miit.gov.cn/', //备好号网址
};
